export const customApp = 'ix-app';
export const customAppTrain = 'stable';
export const appImagePlaceholder = 'assets/images/truenas_scale_ondark_favicon.png';
export const latestVersion = 'latest';
